module.exports = __webpack_public_path__ + "media/images/carbon_hospitals/common/hospital_page_key_v-32e5feddbbe26abe017280c2b5c13b88.jpg";